// extracted by mini-css-extract-plugin
export default {"navigation-controller":"NavigationController_navigation-controller__4pLx3","navigation-controller-tab":"NavigationController_navigation-controller-tab__54kyI"};